// BrandLogo.jsx
import React from "react";
import "./BrandLogo.css";

const PALETTE = [
  { bg: "#0E2623", fg: "#C6A87C", ring: "#C6A87C" },
  { bg: "#1A2A26", fg: "#D9BC93", ring: "#D9BC93" },
  { bg: "#0A1D1A", fg: "#7BC8A6", ring: "#2A7E5D" },
  { bg: "#152422", fg: "#E7D9C0", ring: "#C6A87C" },
  { bg: "#0E1F1C", fg: "#A8C9B7", ring: "#7BC8A6" },
];

function hashIndex(str) {
  let h = 0;
  for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) | 0;
  return Math.abs(h) % PALETTE.length;
}

export default function BrandLogo({
  company,
  size = 56,
  square = true,
  className = "",
}) {
  const initials = company
    .split(/\s+/)
    .map((w) => w[0])
    .filter(Boolean)
    .slice(0, 2)
    .join("")
    .toUpperCase();

  const c = PALETTE[hashIndex(company)];
  const fontSize = Math.round(size * 0.36);
  const radius = square ? Math.round(size * 0.22) : size / 2;

  return (
    <div
      data-testid={`brand-logo-${company}`}
      className={`brandLogoTile ${className}`}
      style={{
        "--brand-logo-size": `${size}px`,
        "--brand-logo-bg": c.bg,
        "--brand-logo-fg": c.fg,
        "--brand-logo-radius": `${radius}px`,
        "--brand-logo-border": `${c.ring}33`,
        "--brand-logo-font-size": `${fontSize}px`,
      }}
      aria-label={company}
      title={company}
    >
      {initials || "·"}
    </div>
  );
}
